import { render, staticRenderFns } from "./SelectDeliveryCompany.vue?vue&type=template&id=94cf2330"
import script from "./SelectDeliveryCompany.vue?vue&type=script&lang=js"
export * from "./SelectDeliveryCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports